import { Typography, Button, Alert } from "@mui/material";

const PriceSummary = ({
  language,
  totalPrice,
  servicesPrice,
  utilityPrice,
  totalItemsCount,
  hasServices,
  hasUtilityItems,
  validationErrors,
  isBookingAllowed,
  onBookForLater
}) => {
  return (
    <div className="services-summary">
      <div className="total-row">
        <span className="total-label">
          {language === "ar" ? "المجموع:" : "Total:"}
        </span>
        <span className="total-price">
          {totalPrice} {language === "ar" ? "ر.س" : "SAR"}
        </span>
      </div>

      <div className="selected-services-count">
        <span>
          {language === "ar"
            ? `إجمالي العناصر: ${totalItemsCount}`
            : `Total items: ${totalItemsCount}`}
        </span>
        {hasServices && (
          <div style={{ fontSize: "13px", color: "#888", marginTop: "4px" }}>
            {language === "ar" 
              ? `الخدمات: ${servicesPrice} ر.س`
              : `Services: ${servicesPrice} SAR`
            }
          </div>
        )}
        {hasUtilityItems && (
          <div style={{ fontSize: "13px", color: "#888", marginTop: "4px" }}>
            {language === "ar" 
              ? `المستلزمات: ${utilityPrice} ر.س`
              : `Utility Items: ${utilityPrice} SAR`
            }
          </div>
        )}
      </div>

      {validationErrors.map((error, index) => (
        <Alert
          key={index}
          severity="warning"
          sx={{
            margin: "10px 0",
            "& .MuiAlert-message": {
              fontSize: "14px",
              direction: language === "ar" ? "rtl" : "ltr",
            },
          }}
        >
          {error.message[language]}
        </Alert>
      ))}

      <div className="action-buttons">
        <Button
          variant="contained"
          color={isBookingAllowed ? "success" : "default"}
          className="search-worker-button"
          onClick={onBookForLater}
          disabled={!isBookingAllowed}
          sx={{
            backgroundColor: !isBookingAllowed ? "#ccc" : undefined,
            "&:hover": {
              backgroundColor: !isBookingAllowed ? "#ccc" : undefined,
            },
            "&.Mui-disabled": {
              color: "#666",
              backgroundColor: "#e0e0e0",
            },
          }}
        >
          {language === "ar" ? "احجز موعداً" : "Book Appointment"}
        </Button>
      </div>
    </div>
  );
};

export default PriceSummary;